import React, {PropTypes} from 'react';
import moment from 'moment-timezone';
import 'moment/locale/nb';

const DateTimeFormatter = ({value, title, hide, format}) => {
  format = format || 'DD.MM.YYYY HH:mm';
  if(value != undefined || hide == false) {
    return (
      <div className="datetime-wrapper">
        <strong>{title}</strong>
        {value && moment.tz(value, 'Europe/Oslo').format(format)}
        {!value && ' - '}
      </div>
    );
  } else {
    return null;
  }
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
DateTimeFormatter.propTypes = {
  value: PropTypes.string,
  format: PropTypes.string,
  title: PropTypes.string,
  hide: PropTypes.bool,
};

export default DateTimeFormatter;



/** WEBPACK FOOTER **
 ** ./src/components/DateTimeFormatter.js
 **/